import Icon from '../../components/Icon.vue'

Icon.register({"brands/vimeo-square":{"width":448,"height":512,"paths":[{"d":"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM383.8 181.6C382.4 212.7 360.6 255.4 318.5 309.5 275 366 238.2 394.3 208.1 394.3 189.4 394.3 173.7 377.1 160.8 342.7 135.6 250.4 124.9 196.3 104.1 196.3 101.7 196.3 93.3 201.3 79 211.4L64 192C100.9 159.6 136.1 123.6 158.1 121.6 183 119.2 198.3 136.2 204.1 172.7 224.6 302.3 233.7 321.9 270.9 263.2 284.3 242 291.5 226 292.4 214.9 295.8 182.1 266.8 184.3 247.2 192.7 262.9 141.2 293 116.2 337.3 117.6 370.2 118.6 385.7 140 383.8 181.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/vimeo-square.js
// module id = LyB0
// module chunks = 0